import React from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as actions from '../../store/actions/InterviewInviteActions';
import styles from './InterviewerLoginForm.scss';
import { connect } from 'react-redux';
import { loginInterviewRequest } from '../../store/actions/AuthActions';

const InterviewerLoginForm = ({ loginHandler, startInterview, interview_id }) => {
  const { t } = useTranslation('auth');
  const [form] = Form.useForm();

  const onFinish = values => {
    const payload = {
      emailId: values.email,
      password: values.password,
      callback: () => startInterview(interview_id),
    };
    loginHandler(payload);
  };

  return (
    <Form
      form={form}
      className={styles.form}
      onFinish={onFinish}
      initialValues={{ remember: true }}
      layout="vertical"
    >
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: t('interviewer_login.validation.email_required'),
          },
        ]}
      >
        <Input
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder={t('interviewer_login.placeholder.email')}
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: t('interviewer_login.validation.password_required'),
          },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder={t('interviewer_login.placeholder.password')}
        />
      </Form.Item>

      <Form.Item>
        <Form.Item
          name="remember"
          valuePropName="checked"
          noStyle
        >
          <Checkbox>{t('interviewer_login.remember_me')}</Checkbox>
        </Form.Item>

        <Link
          className={styles['form__forgot']}
          to="#"
        >
          {t('interviewer_login.forgot_password')}
        </Link>

        <Button
          type="primary"
          htmlType="submit"
          className={styles['form__button']}
          block
        >
          {t('interviewer_login.submit')}
        </Button>
      </Form.Item>
    </Form>
  );
};

const mapStateToProps = state => ({
  interview_id: state.interview.interview_id,
});

const mapDispatchToProps = dispatch => ({
  loginHandler: values => dispatch(loginInterviewRequest(values)),
  startInterview: interview_id => dispatch(actions.startInterview(interview_id)),
});

InterviewerLoginForm.propTypes = {
  loginHandler: PropTypes.func,
  startInterview: PropTypes.func,
  interview_id: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(InterviewerLoginForm);
